(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/xpert-coupon.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/xpert-coupon.js');

'use strict';

const Button = svs.ui.Button;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  fetchXpert,
  fetchXpertCustom
} = svs.racing.raceService;
const {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} = React;
const XpertPicker = svs.racing_game.components.play.XpertPicker;
const Dialog = svs.components.dialog;
const api = svs.components.dialog.api;
const getDrawOfGameType = svs.racing.common.util.getDrawOfGameType;
const {
  quickpickProps,
  systemTypes
} = svs.racing.common.constants;
const {
  getCancelledParticipants
} = svs.racing.common.util;
const {
  ReactIcon
} = svs.ui;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_LG
} = svs.components.lbUtils.useMediaQuery;
const PlayContext = svs.racing_game.components.playContext.PlayContext;
const CouponContext = svs.racing_game.components.playContext.CouponContext;
const isMobile = svs.core.detect.formfactor.mobile();
const createConfirmDialog = _ref => {
  let {
    description,
    abortCallback,
    confirmCallback
  } = _ref;
  return new Dialog.Confirm({
    branding: svs.components.dialog.branding.SPORT,
    icon: 'dustbin',
    area: svs.components.dialog.area.POPUP,
    product: 'Racing',
    title: 'Rensar tidigare val',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: description,
      align: svs.components.dialog.message.align.CENTER
    }],
    actions: [{
      title: 'Avbryt',
      callback: abortCallback
    }, {
      title: 'Fortsätt',
      callback: confirmCallback
    }]
  });
};
const XpertCoupon = _ref2 => {
  let {
    handleXpertenFetched,
    isDisabled,
    disabledReason
  } = _ref2;
  const {
    engine,
    race
  } = useContext(PlayContext);
  const hasAnySet = useMemo(() => engine && engine.selectors && engine.selectors.hasAnySet && engine.selectors.hasAnySet(), [engine]);
  const qpValue = useMemo(() => engine && engine.selectors && engine.selectors.getQP ? engine.selectors.getQP() : undefined, [engine]);
  const [hasGenerated, setHasGenerated] = useState(qpValue && qpValue !== quickpickProps.NOQP);
  const xpertValues = useMemo(() => engine && engine.xpert && engine.xpert.data ? engine.xpert.data : [], [engine]);
  const numActiveParticipants = useMemo(() => race && race.participants ? race.numberOfParticipants - getCancelledParticipants(race.participants).length : 0, [race]);
  const {
    selectedAmount,
    setSelectedAmount
  } = useContext(CouponContext);
  const [selectedSystemSize, setSelectedSystemSize] = useState(0);
  const drawNumber = useMemo(() => getDrawOfGameType(race, engine.gameType).drawNumber, [race, engine.gameType]);
  const isWideMode = useMediaQuery(breakpoints.up(BREAKPOINT_LG));
  const isMax320 = useMediaQuery('(max-width: 320px)');
  const more = xpertValues.length > 9;
  const isTopRankPixAndHasNoCustomPicks = useMemo(() => engine.systemType === systemTypes.TOP_RANK_PIX && engine.selectors.isNoPositionsCustomPicked(), [engine]);
  const shouldRenderResetButton = engine.systemType === systemTypes.TOP_RANK_PIX && engine.selectors.isXpertenFetched();
  useEffect(() => {
    setSelectedSystemSize(0);
  }, [selectedAmount]);
  const [previousQpValue, setPreviousQpValue] = useState(qpValue);
  useEffect(() => {
    const timer = setTimeout(() => {
      const newQpValue = engine.selectors.getQP();
      if (newQpValue !== previousQpValue && previousQpValue === quickpickProps.WEIGHTEDQP) {
        setSelectedSystemSize(0);
      }
      if (newQpValue !== previousQpValue && newQpValue === quickpickProps.NOQP) {
        setHasGenerated(false);
      }
      setPreviousQpValue(qpValue);
    }, 250);
    return () => {
      clearTimeout(timer);
    };
  }, [qpValue, engine.selectors]);
  const handleError = () => {
    const dialog = new svs.components.dialog.Confirm({
      icon: 'help-2',
      branding: svs.components.dialog.branding.SPORT,
      title: 'Något gick tyvärr fel',
      type: svs.components.dialog.type.ERROR,
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Prova igen om en stund.'
      }],
      actions: [{
        title: 'Ok'
      }]
    });
    svs.components.dialog.api.add(dialog);
  };
  const handleFetchXpert = useCallback(() => {
    if (engine.systemType === systemTypes.TOP_RANK_PIX) {
      fetchXpertCustom(drawNumber, selectedSystemSize, engine.selectors.getPixCustomBody(), (err, xpertWager) => {
        if (err) {
          handleError();
        } else if (xpertWager) {
          handleXpertenFetched(xpertWager);
          setHasGenerated(true);
        }
      });
    } else {
      fetchXpert(drawNumber, selectedSystemSize, (err, xpertWager) => {
        if (err) {
          handleError();
        } else if (xpertWager) {
          handleXpertenFetched(xpertWager);
          setHasGenerated(true);
        }
      });
    }
  }, [drawNumber, selectedSystemSize, handleXpertenFetched, engine.systemType]);
  const handleFetchClicked = useCallback(() => {
    if (engine.systemType === systemTypes.TOP_RANK_PIX) {
      engine.actions.setIsXpertenFetched(true);
      engine.actions.clearRow();
    } else {
      engine.actions.clearAll();
    }
    handleFetchXpert();
    setSelectedAmount();
  }, [engine, setSelectedAmount, handleFetchXpert]);
  const onFetchClicked = useCallback(() => {
    if (hasAnySet && engine.selectors.getQP() !== quickpickProps.WEIGHTEDQP && engine.systemType !== systemTypes.TOP_RANK_PIX) {
      const dialog = createConfirmDialog({
        description: 'Dina tidigare val kommer att ersättas med val från PIX!',
        abortCallback: () => {
          dialog.close();
        },
        confirmCallback: () => {
          dialog.close();
          engine.actions.clearAll();
          handleFetchClicked();
        }
      });
      api.add(dialog);
    } else {
      handleFetchClicked();
    }
  }, [hasAnySet, engine.selectors, handleFetchClicked]);
  const onClearClicked = () => {
    const dialog = createConfirmDialog({
      description: 'Dina tidigare val kommer att rensas och du börjar om.',
      abortCallback: () => {
        dialog.close();
      },
      confirmCallback: () => {
        dialog.close();
        engine.actions.clearAll();
        setSelectedAmount();
      }
    });
    api.add(dialog);
  };
  const renderButton = () => React.createElement(Button, {
    block: true,
    disabled: selectedSystemSize === 0 || isDisabled || isTopRankPixAndHasNoCustomPicks,
    iconPosition: "right",
    inverted: true,
    onClick: onFetchClicked
  }, React.createElement("span", {
    className: "f-200"
  }, hasGenerated ? React.createElement(React.Fragment, null, !isMax320 && shouldRenderResetButton && React.createElement(ReactIcon, {
    className: "icon-racing-btn-refresh",
    icon: "refresh",
    size: "100"
  }), "Generera ny PIX!") : 'Låt PIX! fylla i kupongen'));
  const renderResetButton = () => React.createElement(Button, {
    block: true,
    iconPosition: "right",
    onClick: () => onClearClicked(),
    transparent: true
  }, React.createElement("span", {
    className: "f-200"
  }, !isMax320 && React.createElement(ReactIcon, {
    className: "icon-racing-btn-dustbin",
    icon: "dustbin",
    size: "100"
  }), "B\xF6rja om"));
  const renderPixChoiceText = () => {
    if (isMobile) {
      return React.createElement("p", {
        className: "f-bold f-center padding-1"
      }, "G\xF6r minst en och max ".concat(selectedSystemSize === 1 ? ' fyra ' : ' fem ', " markeringar i kupongen nedanf\xF6r. Endast en markering per position \xE4r till\xE5ten."));
    }
    return React.createElement("p", {
      className: "f-bold f-center padding-1"
    }, "G\xF6r minst en och max ".concat(selectedSystemSize === 1 ? ' fyra ' : ' fem ', " markeringar i kupongen nedanf\xF6r."), React.createElement("br", null), "Endast en markering per position \xE4r till\xE5ten.");
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "xpert-mode-holder"
  }, React.createElement("div", {
    className: "picker-header"
  }, "V\xE4lj insats")), React.createElement("div", {
    className: "xpert-coupon".concat(isWideMode ? ' padding-xs-1' : ' padding-xs-h-1 padding-xs-top-1')
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    lg: {
      gutter: 0
    },
    md: {
      gutter: 0
    },
    sm: {
      gutter: 0
    },
    xl: {
      gutter: 0
    },
    xs: {
      gutter: 0
    }
  }, React.createElement(GridCol, {
    lg: 12,
    md: 12
  }, React.createElement(XpertPicker, {
    isAllCustomPicks: engine.systemType === systemTypes.TOP_RANK_PIX ? engine.selectors.isAllPositionsCustomPicked() : false,
    isMultipleLines: more ? true : !isWideMode,
    numActiveParticipants: numActiveParticipants,
    selectedSystemSize: selectedSystemSize,
    setSelectedSystemSize: setSelectedSystemSize,
    xpertData: xpertValues
  })), isDisabled && React.createElement(GridCol, null, React.createElement("div", {
    className: "error align-center padding-xs-1"
  }, React.createElement(ReactIcon, {
    color: "fc-red",
    icon: "exclamation-sign",
    size: "300"
  }), React.createElement("div", {
    className: "fc-red"
  }, disabledReason)))))), React.createElement("div", {
    className: "".concat(isWideMode && 'xpert-coupon-sticky')
  }, React.createElement(Grid, null, isWideMode && React.createElement(GridRow, {
    lg: {
      gutter: 0
    }
  }, React.createElement(GridCol, {
    lg: shouldRenderResetButton ? 2 : 3
  }), shouldRenderResetButton ? React.createElement(React.Fragment, null, React.createElement(GridCol, {
    lg: 4
  }, React.createElement("div", {
    className: "padding-xs-1"
  }, renderResetButton())), React.createElement(GridCol, {
    lg: 4
  }, React.createElement("div", {
    className: "padding-xs-top-1 padding-xs-bottom-1"
  }, renderButton()))) : React.createElement(GridCol, {
    lg: 6
  }, React.createElement("div", {
    className: "margin-xs-left-1 padding-xs-1"
  }, renderButton())), React.createElement(GridCol, {
    lg: shouldRenderResetButton ? 2 : 3
  })))), !isWideMode && !shouldRenderResetButton && React.createElement("div", {
    className: "xpert-coupon xpert-coupon-sticky padding-xs-1"
  }, renderButton()), !isWideMode && shouldRenderResetButton && React.createElement("div", {
    className: "xpert-coupon xpert-coupon-sticky padding-xs-1"
  }, React.createElement(GridRow, {
    md: {
      gutter: 0
    },
    sm: {
      gutter: 0
    },
    xl: {
      gutter: 0
    },
    xs: {
      gutter: 0
    }
  }, React.createElement(GridCol, {
    md: 4,
    sm: 6,
    xs: 6
  }, React.createElement("div", {
    className: "padding-xs-1"
  }, renderResetButton())), React.createElement(GridCol, {
    md: 8,
    sm: 6,
    xs: 6
  }, React.createElement("div", {
    className: "padding-xs-top-1 padding-xs-bottom-1"
  }, renderButton())))), engine.systemType === systemTypes.TOP_RANK_PIX && renderPixChoiceText());
};
XpertCoupon.defaultProps = {
  disabledReason: 'Loppet är tillfälligt stängt'
};
svs.racing_game.components.play.XpertCoupon = XpertCoupon;

 })(window);